import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {AgendaEventDetailsDialogFooter} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialogFooter'
import {AgendaEventDetailsDialogBody} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialogBody'
import {AgendaEventDetailsDialogHeader} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialogHeader'
import {AgendaEventDetailsFormProvider} from '@/features/agenda/components/agenda-event-form/agenda-event-details-form-provider/AgendaEventDetailsFormProvider'
import {AgendaEventAppointment, EventExtended} from '@/features/agenda/types'
import {EditEventFormValidationSchema} from '@/features/agenda/formSchemas'

interface AgendaEventDetailsAppointmentDialogContentProps {
    agendaEvent: AgendaEventAppointment
    agendaEventDefaultValues: EditEventFormValidationSchema
    data: EventExtended
}

export const AgendaEventDetailsAppointmentDialogContent = ({
    agendaEvent,
    agendaEventDefaultValues,
    data
}: AgendaEventDetailsAppointmentDialogContentProps) => {
    const repetitionData =
        agendaEventDefaultValues?.category == 'treatments' ? agendaEventDefaultValues?.repetitionData : undefined

    return (
        <AgendaEventDetailsFormProvider defaultValues={agendaEventDefaultValues}>
            <AgendaEventDetailsDialogHeader
                agendaEvent={agendaEvent}
                isARecovery={!!agendaEventDefaultValues?.isARecovery}
            />
            <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                <AgendaEventDetailsDialogBody event={data} />
            </ScrollArea>
            <AgendaEventDetailsDialogFooter agendaEvent={agendaEvent} repetitionData={repetitionData} />
        </AgendaEventDetailsFormProvider>
    )
}
